/**
 * @description 加密工具类
 * @author Cursor
 * @date 2024-04-19
 */

// write by cursor
import CryptoJS from 'crypto-js';

const SECRET_KEY = 'N2E0ZjJlOGMxYjlkM2Y2YTBlNWM4YjJhMWQ3ZjNlOTA=';

export class CryptoService {
  /**
   * 加密数据
   * @param data 要加密的数据
   * @returns 加密后的字符串
   */
  static encrypt(data: any): string {
    try {
      const jsonStr = typeof data === 'string' ? data : JSON.stringify(data);
      
      // 使用AES算法加密
      const keyWordArray = CryptoJS.enc.Utf8.parse(SECRET_KEY);
      const encrypted = CryptoJS.AES.encrypt(jsonStr, keyWordArray, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      
      // 返回base64格式的加密字符串
      return encrypted.toString();
    } catch (error) {
      console.error('encrypt failed:', error);
      return '';
    }
  }

  /**
   * 解密数据
   * @param encryptedData 加密后的字符串
   * @returns 解密后的数据
   */
  static decrypt(encryptedData: string): any {
    try {
      const keyWordArray = CryptoJS.enc.Utf8.parse(SECRET_KEY);
      const decrypted = CryptoJS.AES.decrypt(encryptedData, keyWordArray, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      const jsonStr = decrypted.toString(CryptoJS.enc.Utf8);
      
      return JSON.parse(jsonStr);
    } catch (error) {
      console.error('decrypt failed:', error);
      return null;
    }
  }
} 